module.exports = __webpack_public_path__ + "static/media/loader-big.a770b679.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/react-widgets/img/loader-big.gif
// module id = 336
// module chunks = 0